import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Snackbar } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { getDetalleFactura } from "../../../api/ApiService";


function ZoomableImagePreview({ imagenFactura, emptyMessage, emptyDescription }) {
    const containerRef = useRef(null);
    const [zoom, setZoom] = useState(1);
    const [offset, setOffset] = useState({ x: 0, y: 0 });
    const [dragState, setDragState] = useState({
        isDragging: false,
        startX: 0,
        startY: 0,
        originX: 0,
        originY: 0,
    });

    useEffect(() => {
        const containerElement = containerRef.current;

        if (!containerElement) {
            return undefined;
        }

        const handleWheel = (event) => {
            if (!imagenFactura) return;

            event.preventDefault();

            const zoomStep = event.deltaY < 0 ? 0.12 : -0.12;
            setZoom((currentZoom) => {
                const nextZoom = currentZoom + zoomStep;
                const normalizedZoom = Math.min(3, Math.max(1, Number(nextZoom.toFixed(2))));

                if (normalizedZoom === 1) {
                    setOffset({ x: 0, y: 0 });
                }

                return normalizedZoom;
            });
        };

        containerElement.addEventListener("wheel", handleWheel, { passive: false });

        return () => {
            containerElement.removeEventListener("wheel", handleWheel);
        };
    }, [imagenFactura]);

    const handleMouseDown = (event) => {
        if (!imagenFactura || zoom <= 1) return;

        setDragState({
            isDragging: true,
            startX: event.clientX,
            startY: event.clientY,
            originX: offset.x,
            originY: offset.y,
        });
    };

    const handleMouseMove = (event) => {
        if (!dragState.isDragging || zoom <= 1) return;

        const deltaX = event.clientX - dragState.startX;
        const deltaY = event.clientY - dragState.startY;

        setOffset({
            x: dragState.originX + deltaX,
            y: dragState.originY + deltaY,
        });
    };

    const handleMouseUp = () => {
        setDragState((currentState) => ({
            ...currentState,
            isDragging: false,
        }));
    };

    const handleMouseLeave = () => {
        handleMouseUp();
        setZoom(1);
        setOffset({ x: 0, y: 0 });
    };

    return (
        <div
            ref={containerRef}
            className="group relative min-h-[420px] w-full overflow-hidden rounded-lg border border-gray-200 bg-[#f1f5f9] shadow-sm"
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseLeave}
        >
            {imagenFactura ? (
                <>
                    <img
                        src={imagenFactura}
                        alt="imagen factura"
                        draggable={false}
                        className={`h-full w-full object-contain transition-transform duration-200 ease-out select-none ${zoom > 1 ? (dragState.isDragging ? "cursor-grabbing" : "cursor-grab") : "group-hover:cursor-zoom-in"}`}
                        style={{
                            transform: `scale(${zoom}) translate(${offset.x / zoom}px, ${offset.y / zoom}px)`,
                            transformOrigin: "center center",
                        }}
                    />

                    <div className="pointer-events-none absolute inset-x-4 bottom-4 rounded-xl bg-black/55 px-3 py-2 text-xs text-white opacity-0 transition-opacity duration-200 group-hover:opacity-100">
                        Usa la rueda del mouse para acercar o alejar la imagen. Arrastra para moverla.
                    </div>
                </>
            ) : (
                <div className="flex h-full flex-col items-center justify-center p-6 text-center">
                    <p className="text-base font-semibold text-gray-700">{emptyMessage}</p>
                    {emptyDescription ? (
                        <p className="mb-5 text-sm text-gray-500">{emptyDescription}</p>
                    ) : null}
                </div>
            )}
        </div>
    );
}


function FacturaDetallePage() {
    const [cargando, setCargando] = useState(false);
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [dataFactura, setDataFactura] = useState(null);


    const stateToken = useSelector(state => state.reducerGlobal.token);
    const params = useParams();
    const navigate = useNavigate();

    const { id } = params;


    useEffect(() => {
        if (id) {
            if (stateToken) {
                handleDetalleFactura();
            }
        }
    }, [id, stateToken]);




    //==========================================================funcion para detalle de factura
    const handleDetalleFactura = () => {
        getDetalleFactura(stateToken?.access_token, id)
            .then(response => {
                setDataFactura(response || null);
                setCargando(true);
            })
            .catch(() => {
                setCargando(true);
                setMensaje("Error al cargar los datos");
                setSeverity('error');
                setOpen(true);
            })
    }




    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };







    const handleVolver = () => {
        navigate(-1);
    };

    const factura = dataFactura?.data || dataFactura || {};
    const local = factura?.local || {};
    const cliente = factura?.cliente || {};
    const procesador = factura?.procesador || {};
    const imagenFactura = factura?.imagen && factura?.imagen !== "#" ? factura?.imagen : null;

    const InfoRow = ({ label, value, noBorder = false }) => (
        <div className={`grid grid-cols-1 gap-2 py-2 sm:grid-cols-2 ${noBorder ? "" : "border-b border-gray-100"}`}>
            <p className="text-sm font-bold text-gray-800">{label}:</p>
            <p className="text-sm text-gray-700">{value || "-"}</p>
        </div>
    );

    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="mx-auto max-w-6xl">
                    <div className="mb-4 flex items-center justify-between gap-3">
                        <h1 className="text-2xl font-bold text-gray-800">Detalle de factura</h1>
                        <button
                            type="button"
                            onClick={handleVolver}
                            className="rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-semibold text-gray-700 shadow-sm transition-colors hover:bg-gray-50"
                        >
                            Volver
                        </button>
                    </div>

                    {cargando ? (
                        <div className="space-y-6">
                            <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
                                <h2 className="mb-3 text-lg font-bold text-gray-800">Resumen</h2>
                                <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
                                    <div className="rounded-lg border border-gray-200 bg-[#f8fafc] p-4">
                                        <p className="text-xs font-semibold uppercase text-gray-500">Monto</p>
                                        <p className="mt-1 text-xl font-bold text-gray-800">{factura?.monto_formateado ? `Gs. ${factura?.monto_formateado}` : "Gs. 0"}</p>
                                    </div>
                                    <div className="rounded-lg border border-gray-200 bg-[#f8fafc] p-4">
                                        <p className="text-xs font-semibold uppercase text-gray-500">Estado</p>
                                        <p className="mt-1 text-xl font-bold text-gray-800">{factura?.estado_label || factura?.estado || "-"}</p>
                                    </div>
                                    <div className="rounded-lg border border-gray-200 bg-[#f8fafc] p-4">
                                        <p className="text-xs font-semibold uppercase text-gray-500">Fecha factura</p>
                                        <p className="mt-1 text-xl font-bold text-gray-800">{factura?.fecha_formateada || factura?.fecha || "-"}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="grid grid-cols-1 gap-6 xl:grid-cols-5">
                                <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm xl:col-span-3">
                                    <h2 className="mb-3 text-lg font-bold text-gray-800">Datos de la factura</h2>
                                    <div className="space-y-0">
                                        {/* <InfoRow label="ID" value={factura?.id} /> */}
                                        <InfoRow label="Nro Factura" value={factura?.nro_factura} />
                                        <InfoRow label="Monto" value={factura?.monto_formateado ? `Gs. ${factura?.monto_formateado}` : "-"} />
                                        <InfoRow label="Moneda" value={factura?.moneda} />
                                        <InfoRow label="Fecha" value={factura?.fecha_formateada || factura?.fecha} />
                                        <InfoRow label="Estado" value={factura?.estado_label || factura?.estado} />
                                        <InfoRow label="Procesado por" value={factura?.procesado_por} />
                                        <InfoRow label="Puntos" value={factura?.puntos} />
                                        <InfoRow label="Observación" value={factura?.observacion} />
                                        <InfoRow label="Creado" value={factura?.created_at_formateado || factura?.created_at} noBorder />
                                    </div>
                                </div>

                                <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm xl:col-span-2">
                                    <h2 className="mb-3 text-lg font-bold text-gray-800">Imagen de factura</h2>
                                    <ZoomableImagePreview
                                        imagenFactura={imagenFactura}
                                        emptyMessage="No hay imagen de factura"
                                        emptyDescription="No se encontró una imagen para esta factura."
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
                                <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
                                    <h2 className="mb-3 text-lg font-bold text-gray-800">Local</h2>
                                    <div className="space-y-0">
                                        {/* <InfoRow label="ID" value={local?.id} /> */}
                                        <InfoRow label="Nombre fantasia" value={local?.nombre_fantasia} />
                                        <InfoRow label="RUC" value={local?.ruc} noBorder />
                                    </div>
                                </div>

                                <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
                                    <h2 className="mb-3 text-lg font-bold text-gray-800">Cliente</h2>
                                    <div className="space-y-0">
                                        {/* <InfoRow label="Usuario ID" value={cliente?.usuario_id} />
                                        <InfoRow label="User ID" value={cliente?.user_id} /> */}
                                        <InfoRow label="Nombre completo" value={cliente?.nombre_completo} />
                                        <InfoRow label="Nombres" value={cliente?.first_name} />
                                        <InfoRow label="Apellidos" value={cliente?.last_name} />
                                        <InfoRow label="Email" value={cliente?.email} noBorder />
                                    </div>
                                </div>
                            </div>

                            <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
                                <h2 className="mb-3 text-lg font-bold text-gray-800">Procesador</h2>
                                <div className="space-y-0">
                                    {/* <InfoRow label="ID" value={procesador?.id} /> */}
                                    <InfoRow label="Nombre completo" value={procesador?.nombre_completo} />
                                    <InfoRow label="Nombres" value={procesador?.first_name} />
                                    <InfoRow label="Apellidos" value={procesador?.last_name} />
                                    <InfoRow label="Email" value={procesador?.email} noBorder />
                                </div>
                            </div>
                        </div>
                    ) :
                        (
                            <div className="bg-white rounded-xl shadow-md p-8">
                                <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                                <div className="space-y-4">
                                    <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                    <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                    <div className="h-24 bg-gray-200 rounded animate-pulse" />
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>


            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default FacturaDetallePage;